<template>
  <div class="cswitch_container" :class="{ 'is-checked': checked }" :style="containerStyle" @click="onToggle">
    <div class="cswitch_thumb" :style="thumbStyle"></div>
  </div>
</template>

<script lang="ts" setup>
import { Brand, getBrand } from '@/brand/brand'
import { computed, onMounted, ref } from 'vue'

const props = defineProps({
  width: {
    type: Number,
    required: true,
  },
  height: {
    type: Number,
    required: true,
  },
  checked: {
    type: Boolean,
    required: true,
  },
  click: {
    type: Function as any,
    required: true,
  },
  bgFill: {
    type: String,
    required: false,
  },
})

const activeColor = ref('var(--color-brand-2)')

onMounted(async () => {
  const brand = await getBrand()
  if (brand === Brand.carotmas) {
    activeColor.value = '#78CEE9'
  } else {
    activeColor.value = 'var(--color-brand-2)'
  }
})

const onToggle = () => {
  if (props.click) {
    props.click()
  }
}

const containerStyle = computed(() => {
  return {
    width: `${props.width}px`,
    height: `${props.height}px`,
    backgroundColor: props.checked ? activeColor.value : props.bgFill || 'rgba(0, 0, 0, 0.1)',
  }
})

const thumbStyle = computed(() => {
  const size = props.height - 4
  const offset = props.checked ? props.width - size - 2 : 2
  return {
    width: `${size}px`,
    height: `${size}px`,
    left: `${offset}px`,
  }
})
</script>

<style lang="less" scoped>
.cswitch_container {
  position: relative;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  overflow: hidden;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);

  &.is-checked {
    box-shadow:
      0 4px 10px rgba(0, 0, 0, 0.1),
      inset 0 1px 2px rgba(255, 255, 255, 0.2);
  }

  .cswitch_thumb {
    position: absolute;
    top: 2px;
    background: #ffffff;
    border-radius: 50%;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }
}
</style>
